import { h, render } from "preact";
import RichText from "../helpers/richText";

export default function CompareContentItem({ compareContent }) {
  return (
    <div className="compare-modal-v2__compare-content">
      {compareContent.svg && (
        <div
          className="compare-modal-v2__compare-icon"
          dangerouslySetInnerHTML={{
            __html: compareContent.svg,
          }}
        ></div>
      )}
      <RichText
        className="compare-modal-v2__compare-content-content"
        schema={compareContent.content}
      />
    </div>
  );
}
